<template>
  <div class="col-xl-12 col-lg-12 col-sm-12 col-md-12 mt-3">
    <generalForm typeForm="file" :variableData="variableDataComponent">
      <template v-slot="{}">
        <b-tab id="obs1" title="Tipo de Campo" class="px-1">
          <ValidationObserver ref="obs1">
            <b-card class="card-form shadow">
              <div class="row">
                <div
                  class="col-sm-12 col-xs-12 col-md-12 col-lg-5 col-xl-5 mt-2"
                >
                  <InputText
                    id="maximumSize"
                    name="maximumSize"
                    label="Tamaño máximo (KB)"
                    type="number"
                    :validate="`integer|required|minmax:0,120000`"
                    :helpText="
                      variableDataComponent.config.maximumSize > 0
                        ? `${(
                            variableDataComponent.config.maximumSize / 1024
                          ).toFixed(2)}MB`
                        : ''
                    "
                    placeholder="Escriba el Máximo"
                    :value.sync="variableDataComponent.config.maximumSize"
                  />
                </div>
              </div>
            </b-card>
          </ValidationObserver>
        </b-tab>
      </template>
    </generalForm>
  </div>
</template>

<script>
import generalForm from '@/src/components/variables/general-form'
import InputText from '@components/form/InputText'

export default {
  name: 'fileComponent',
  components: {
    generalForm,
    InputText,
  },
  props: {
    variableDataComponent: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      defaultConfig: {
        maximumSize: null,
        acceptExtensions: '.pdf',
      },
    }
  },
  mounted() {
    if (Object.keys(this.variableDataComponent.config).length === 0) {
      this.variableDataComponent.config = this.defaultConfig
    }
  },
}
</script>
